import { connect } from 'react-redux';
import { publishDraftTier } from '../../Tier/redux/creator/actions';
import { pushModal } from '../../Modals/redux/actionCreators';
import { ModalType } from '../../Modals/redux/types';
const mapStateToProps = (state)=>({});
const mapDispatchToProps = (dispatch, props)=>{
    return {
        onPublish: (params)=>dispatch(publishDraftTier(params)),
        onSubmitToTier: ()=>{
            var _props_deviation;
            return dispatch(pushModal(ModalType.DEVIATION_SUBMIT, {
                params: {
                    tierId: props === null || props === void 0 ? void 0 : (_props_deviation = props.deviation) === null || _props_deviation === void 0 ? void 0 : _props_deviation.deviationId
                }
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps);
